export const AL = () => {
  return (
    <>
      <g clipPath="url(#clip0_1073_11335)">
      <g clipPath="url(#clip1_1073_11335)">
      <rect y="96" width="96" height="96" transform="rotate(-90 0 96)" fill="#EF4444"/>
      <circle cx="48" cy="48" r="12" fill="#141414"/>
      </g>
      </g>
      <rect x="2" y="2" width="92" height="92" rx="46" stroke="white" strokeOpacity="0.15" strokeWidth="4"/>
      <defs>
      <clipPath id="clip0_1073_11335">
      <rect width="96" height="96" rx="48" fill="white"/>
      </clipPath>
      <clipPath id="clip1_1073_11335">
      <rect width="96" height="96" rx="24" fill="white"/>
      </clipPath>
      </defs>
    </>
  )
}
